import { Row } from 'antd'
import CIMSCheckbox from '../CIMSCheckbox'
import { CIMSTag } from '../CIMSTag'
import { CIMSChecklistProps } from './types'
import { useKeyedBooleans } from 'hooks/useKeyedBooleans'
import { errorHandler } from 'hooks/errorHandler'

const CIMSChecklist: React.FC<CIMSChecklistProps> = ({ items = [] }) => {
  const [loading, { add, remove }] = useKeyedBooleans()
  return (
    <div>
      {items.map(({ tag, checked, disabled = [], onChange, key }) => (
        <Row
          key={key}
          align="middle"
          justify="space-between"
          style={{ padding: '1px 0px', flexWrap: 'nowrap' }}
        >
          <CIMSTag tooltip={tag.tooltip}>{tag.children}</CIMSTag>
          <CIMSCheckbox
            loading={loading(key)}
            disabled={
              Array.isArray(disabled)
                ? [...disabled, { reason: 'loading', disabled: loading(key) }]
                : [disabled, { reason: 'loading', disabled: loading(key) }]
            }
            checked={checked}
            onChange={async () => {
              add(key)
              try {
                await onChange(key)
              } catch (err) {
                errorHandler(err)
              } finally {
                remove(key)
              }
            }}
          />
        </Row>
      ))}
    </div>
  )
}

export default CIMSChecklist
